import { withRouter, Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { Card, Button, CardBody, Row, Col } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { changeLeaguesStatus, changeLeaguesTopStatus, updateLeagueOneOrTwoUpFeatures } from "helpers/repository"
import TableLoader from "../../../../components/Common/TableLoader";
function Table(props) {
  const [isOpen, setIsOpen] = useState(false)

  const { data } = props

  const [upState, setUpState] = useState({})

  const [loadingRows, setLoadingRows] = useState({})
  const [tableKey, setTableKey] = useState(0)


  const setLeaguesStatus = id => {
    changeLeaguesStatus(id, successSetLeague, errorSetLeague)
  }

  const setLeaguesTopStatus = id => {
    changeLeaguesTopStatus(id, successSetLeague, errorSetLeague)
  }

  const successSetLeague = res => {
    props.getLeagues()
  }

  const errorSetLeague = err => {
    console.log("error")
  }


  useEffect(() => {
    if (!data) return

    setUpState(prev => {
      const next = { ...prev }

      data.forEach(league => {
        if (!next[league.id]) {
          next[league.id] = {
            one_up: !!league.one_up_two_up?.one_up,
            two_up: !!league.one_up_two_up?.two_up,
          }
        }
      })

      return next
    })
  }, [data])


  const handleToggle = async (leagueId, payload) => {

    const prev = upState[leagueId] || {}

    setLoadingRows(s => ({ ...s, [leagueId]: true }))

    setTableKey(k => k + 1)

    setUpState(s => ({
      ...s,
      [leagueId]: {
        ...s[leagueId],
        ...payload,
      },
    }))

    try {
      await updateLeagueOneOrTwoUpFeatures({
        league_id: leagueId,
        one_up: payload.one_up ?? false,
        two_up: payload.two_up ?? false,
      })

      setLoadingRows(s => ({ ...s, [leagueId]: false }))

      setTableKey(k => k + 1)

      props.getLeagues()

    } catch (err) {
      console.log('API call failed, rolling back')
      setUpState(s => ({
        ...s,
        [leagueId]: prev,
      }))

      setLoadingRows(s => ({ ...s, [leagueId]: false }))

      setTableKey(k => k + 1)
    }
  }


  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      formatter: (cellContent, row) => {
        return row.bb_id
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "Sport",
      text: "Sport",
      sort: true,
      formatter: (cellContent, row) => {
        return row?.sport?.name
      },
    },
    {
      dataField: "location",
      text: "Location",
      sort: true,
      formatter: (cellContent, row) => {
        return row?.location?.name
      },
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "Action",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <Row>
            <Col lg={5}>
              <Button
                onClick={() => {
                  setLeaguesStatus(row.id)
                }}
                type="button"
                color="primary"
                className="btn-sm"
              >
                {row.status == 0 ? "Activate" : "Deactivate"}
              </Button>

              <Button
                onClick={() => {
                  setLeaguesTopStatus(row.id)
                }}
                type="button"
                color="primary"
                className="btn-sm"
                style={{ marginLeft: "10px" }}
                disabled={row.status ? false : true}
              >
                {row.top == 0 ? "Set to Top League" : "Remove From Top League"}
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
    {
      dataField: "oneUpTwoUp",
      text: "1UP / 2UP",
      isDummyField: true,
      formatter: (_, row) => {
        const rowState = upState[row.id] || {}
        const oneUp = rowState.one_up ?? !!row.one_up_two_up?.one_up
        const twoUp = rowState.two_up ?? !!row.one_up_two_up?.two_up

        const isLoading = loadingRows[row.id] === true

        return (
          <div className="d-flex gap-3 align-items-center">
            {/* 1UP Toggle */}
            <div
              className="position-relative"
              style={{
                opacity: isLoading ? 0.7 : 1,
                transition: 'opacity 0.2s ease'
              }}
            >
              <div className="form-check form-switch d-flex align-items-center gap-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id={`oneup-${row.id}`}
                  checked={oneUp}
                  disabled={isLoading}
                  onChange={() =>
                    handleToggle(row.id, {
                      one_up: !oneUp,
                      two_up: twoUp,
                    })
                  }
                  style={{
                    cursor: (isLoading) ? 'not-allowed' : 'pointer',
                    width: '40px',
                    height: '20px'
                  }}
                />
                <label
                  className="form-check-label mb-0"
                  htmlFor={`oneup-${row.id}`}
                  style={{
                    cursor: (isLoading) ? 'not-allowed' : 'pointer',
                    fontWeight: '500',
                    fontSize: '13px',
                    userSelect: 'none'
                  }}
                >
                  <span className={oneUp ? 'text-success' : 'text-muted'}>
                    1UP
                  </span>
                </label>
              </div>

              {oneUp && !isLoading && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#28a745',
                    animation: 'pulse 2s infinite'
                  }}
                />
              )}
            </div>

            {/* Divider */}
            <div style={{
              width: '1px',
              height: '24px',
              backgroundColor: '#e0e0e0'
            }} />

            {/* 2UP Toggle */}
            <div
              className="position-relative"
              style={{
                opacity: isLoading ? 0.7 : 1,
                transition: 'opacity 0.2s ease'
              }}
            >
              <div className="form-check form-switch d-flex align-items-center gap-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id={`twoup-${row.id}`}
                  checked={twoUp}
                  disabled={isLoading}
                  onChange={() =>
                    handleToggle(row.id, {
                      one_up: oneUp,
                      two_up: !twoUp,
                    })
                  }
                  style={{
                    cursor: (isLoading) ? 'not-allowed' : 'pointer',
                    width: '40px',
                    height: '20px'
                  }}
                />
                <label
                  className="form-check-label mb-0"
                  htmlFor={`twoup-${row.id}`}
                  style={{
                    cursor: (isLoading) ? 'not-allowed' : 'pointer',
                    fontWeight: '500',
                    fontSize: '13px',
                    userSelect: 'none'
                  }}
                >
                  <span className={twoUp ? 'text-primary' : 'text-muted'}>
                    2UP
                  </span>
                </label>
              </div>

              {twoUp && !isLoading && (
                <div
                  style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#007bff',
                    animation: 'pulse 2s infinite'
                  }}
                />
              )}
            </div>

            {isLoading && (
              <div
                className="d-flex align-items-center gap-2 px-3 py-1"
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '20px',
                  border: '1px solid #e9ecef',
                  animation: 'fadeIn 0.2s ease'
                }}
              >
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{
                    width: '14px',
                    height: '14px',
                    borderWidth: '2px'
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span
                  style={{
                    fontSize: '12px',
                    color: '#6c757d',
                    fontWeight: '500'
                  }}
                >
                  Saving...
                </span>
              </div>
            )}

            {/* {row.top === 0 && !isLoading && (
              <span
                className="badge bg-warning text-dark"
                style={{
                  fontSize: '10px',
                  padding: '4px 8px',
                  fontWeight: '500'
                }}
              >
                <i className="bx bx-lock-alt me-1" style={{ fontSize: '11px' }}></i>
                Features Locked
              </span>
            )} */}
          </div>
        )
      },
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const { SearchBar } = Search

  const pageOptions = {
    sizePerPage: 20,
    totalSize: props.count,
    custom: true,
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setIsOpen(true)
    },
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Leagues"}</div>
          {
            (props.loadingMessage && props.loadingMessage == "1") ?
              <TableLoader /> :
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField="id"
                columns={columns}
                data={data}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                    keyField="id"
                    data={data}
                    columns={columns}
                    bootstrap4
                    search
                  >
                    {toolkitProps => (
                      <React.Fragment>
                        <Row className="mb-2">
                          <Col sm="6">
                            <Row>
                              <Col sm="6">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col sm={6}></Col>
                        </Row>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                key={tableKey}
                                keyField="id"
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                //   selectRow={selectRow}
                                classes={
                                  "table align-middle table-nowrap table-check"
                                }
                                headerWrapperClasses={"table-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                                rowClasses={"mytable-hover-row"}
                                rowEvents={rowEvents}
                              />
                            </div>
                          </Col>
                        </Row>
                        <div className="pagination pagination-rounded justify-content-end">
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </React.Fragment>
                    )}
                  </ToolkitProvider>
                )}
              </PaginationProvider>}
        </CardBody>
      </Card>
    </>
  )
}

export default Table
